/* tslint:disable */
/* eslint-disable */
/**
 * data-center
 * data-center
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OmniGenerateIFrameUrlRequest
 */
export interface OmniGenerateIFrameUrlRequest {
    /**
     * 
     * @type {string}
     * @memberof OmniGenerateIFrameUrlRequest
     */
    dashboard_id: string;
    /**
     * 
     * @type {string}
     * @memberof OmniGenerateIFrameUrlRequest
     */
    user_timezone?: string;
}

/**
 * Check if a given object implements the OmniGenerateIFrameUrlRequest interface.
 */
export function instanceOfOmniGenerateIFrameUrlRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "dashboard_id" in value;

    return isInstance;
}

export function OmniGenerateIFrameUrlRequestFromJSON(json: any): OmniGenerateIFrameUrlRequest {
    return OmniGenerateIFrameUrlRequestFromJSONTyped(json, false);
}

export function OmniGenerateIFrameUrlRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): OmniGenerateIFrameUrlRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'dashboard_id': json['dashboard_id'],
        'user_timezone': !exists(json, 'user_timezone') ? undefined : json['user_timezone'],
    };
}

export function OmniGenerateIFrameUrlRequestToJSON(value?: OmniGenerateIFrameUrlRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'dashboard_id': value.dashboard_id,
        'user_timezone': value.user_timezone,
    };
}

